export default "__VITE_ASSET__CYMKggFc__"